// src/enduser/eventjudges.jsx
// 審査員一覧（公開）。ログイン不要の公開APIを呼ぶ。
import React from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import PubHeader from "./PubHeader";
import { formatEyebrow } from "./pubutil";
import "./eventcatalog.css";

const API_URL = import.meta.env.VITE_API_URL;

export default function EnduserEventJudges() {
  const { eventId } = useParams();

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["event-judges", "public", eventId],
    queryFn: async () => {
      const res = await axios.get(`${API_URL}/api/public/events/${eventId}/judges/`);
      if (!res.data?.success) throw new Error("審査員の取得に失敗しました");
      return res.data.data;
    },
    // 404（非公開・存在しない）はリトライしない
    retry: (count, err) => err?.response?.status !== 404 && count < 1,
    staleTime: 0,
    refetchOnMount: "always",
  });

  const notFound = isError && error?.response?.status === 404;
  const judges = data?.judges || [];

  return (
    <div className="pubCat">
      <PubHeader to={`/events/${eventId}`} backLabel="戻る" title="審査員" />

      {isLoading ? (
        <div className="pubCatMsg">読み込み中...</div>
      ) : isError ? (
        <div className="pubCatMsg">
          {notFound
            ? "イベントが見つかりません"
            : `エラー: ${error?.message || "審査員の取得に失敗しました"}`}
          <br />
          <Link to="/top">イベント一覧へ戻る</Link>
        </div>
      ) : (
        <>
          <div className="pubCatHero">
            <div className="pubCatInner">
              <div className="pubCatEyebrow">{formatEyebrow(data.event.date)}</div>
              <h1 className="pubCatTitle">{data.event.title}</h1>
              <div className="pubCatRule" />
            </div>
          </div>

          <div className="pubCatInner pubCatBody">
            {judges.length === 0 ? (
              <div className="pubCatMsg">審査員は、まだ公開されていません</div>
            ) : (
              <>
                {judges.map((j) => {
                  const nos = j.group_nos.join("・");
                  return (
                    <div key={j.judge_name} className="pubCatJudge">
                      <div className="pubCatJudgeLabel">{nos ? `${nos}G長` : ""}</div>
                      <div className="pubCatJudgeBody">
                        <div className="pubCatJudgeName">
                          {j.judge_name}
                          {j.special_role && (
                            <span className="pubCatJudgeRole">{j.special_role}</span>
                          )}
                        </div>
                        {nos && <div className="pubCatJudgeGrp">（{nos}G）</div>}
                      </div>
                    </div>
                  );
                })}

                <div className="pubCatNote">※審査員は都合により一部変更することがあります</div>
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
}
